import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
 body{ margin: 0;
  font-family: 'Open Sans', sans-serif;
  color:white;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: rgb(0, 0, 0);
//   padding: 20px 40px;
 }
`;
